import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'patient-covid',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'patient-covid-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                   
                    {                           
                        transKey: 'breadcrumbs.patient-profile-covid',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "patients-profile-index" */ '@/modules/patient-profile/covid/views/Covid.vue')
        }
    ]
}